import React from 'react';
import { StyleSheet, View, Pressable } from 'react-native';
import Icon from '@/components/Icon';
import Text from '@/components/Typography/Text';
import { useTheme } from '@/context/ThemeContext';
import useResponsiveness from '@/hooks/useResponsiveness';

const createStyles = (colors, isDetached, isXS) => StyleSheet.create({
  quoteContainer: {
    paddingHorizontal: 16,
    paddingVertical: 12,
    backgroundColor: colors.solid_color_block,
    borderTopRightRadius: isDetached ? 8 : isXS ? 10 : 24,
    borderTopLeftRadius: isDetached ? 8 : isXS ? 10 : 24,
    borderBottomRightRadius: isDetached ? 8 : 4,
    borderBottomLeftRadius: isDetached ? 8 : 4,
    flexDirection: 'row',
    alignItems: 'flex-start',
    justifyContent: 'space-between',
    gap: 12,
  },
  quoteText: {
    fontSize: 17,
    lineHeight: 24,
    fontWeight: '400',
    textAlign: 'left',
    color: colors.text_color_primary,
    flex: 1,
  },
  quoteIconQuote: {
    paddingTop: 2,
    color: colors.text_color_primary,
  },
  quoteIconCloseBtn: {
    padding: 4,
    borderRadius: 9999,
  },
  quoteIconClose: {
    color: colors.text_color_primary,
  },
});

export default function ChatInputQuoteContainer({
  quote,
  onRemoveQuote,
  isDetached,
}) {
  const { isXS } = useResponsiveness();
  const { colors } = useTheme();
  const styles = React.useMemo(() => createStyles(colors, isDetached, isXS), [colors, isDetached, isXS]);

  if (!quote) return null;

  return (
    <View style={styles.quoteContainer}>
      <Icon 
        name="arrow-turn-down-right" 
        size={16} 
        style={styles.quoteIconQuote} 
        color={colors.text_color_primary} 
      />
      <Text style={styles.quoteText}>{quote}</Text>
      <Pressable 
        style={({ hovered }) => [styles.quoteIconCloseBtn, hovered && { backgroundColor: colors.solid_color_secondary }]} 
        onPress={onRemoveQuote}
      >
        <Icon 
          name="xmark" 
          size={16} 
          style={styles.quoteIconClose} 
          color={colors.text_color_primary} 
        />
      </Pressable>
    </View>
  );
}
